import React, { Component } from 'react';
import { Upload } from '@aws-sdk/lib-storage';
import { S3 } from '@aws-sdk/client-s3';
import { Card, Button, CardBody, Col, Row, Container, FormGroup, Label, Input, CustomInput, Alert, Progress } from "reactstrap";
import Moment from 'moment';

import { addInfoDataStorageUrl } from "../../helpers/url";

import Breadcrumbs from "../../components/Common/Breadcrumb"



export default class DataStore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            breadcrumbItems: [
                {title: "UTJD", link: "/dashboard"},
                {title: "Data Store", link: "#"},
            ],
            iconsrc: ["ri-book-2-fill", "ri-women-fill", "ri-men-fill", "ri-building-fill", "ri-home-gear-fill", "ri-lock-fill", "ri-map-pin-3-fill"],
            
            subject: "",
            description: "",
            comment: "",
            url: "",
            category: "",
            subfolder: "",

            fileName: "",
            fileLocation: "",

            uploaded: 0,
            fileUploading: false,
            fileSuccess: false,
            
            success: null,
            successMsg: "",
            error: null,
            errorMsg: ""
        }
    }
    fileAutoSubmitToS3 = async (event) => {
        this.setState({
            fileUploading: true
        })
        Moment.locale('en');
        let dt = new Date
        let date = Moment(dt).format('YYYY-MM-DD')
        let file = event.target.files[0]
        let fileName = this.state.category + this.state.subfolder + "/" + date + "/" + event.target.files[0].name;

        this.setState({
            fileName: event.target.files[0].name
        })

        const creds = { accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID, secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID };
        const client = new S3({
            region: process.env.REACT_APP_REGION,
            credentials: creds,
         })
        const params = {
            Bucket: process.env.REACT_APP_BUCKET_NAME, 
            Key: fileName, 
            Body: file,
            ACL: 'public-read'
        }
        
        const upload = new Upload({
            client,
            queueSize: 3,
            params,
            type: 'PUT'
        })

        upload.on("httpUploadProgress", (progress) => {
            let uploadedPercent = parseInt((progress.loaded * 100) / progress.total);
            this.setState({
              uploaded: uploadedPercent
            });
        });
        
        await upload.done()
        .then((data) => {
             this.setState({
                 fileLocation: data.Location,
                 fileSuccess: true,
                 fileUploading: false
             })}
        )
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })}
        )
    }

    detailState = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })

    }

    onSend = () => {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken

        fetch(addInfoDataStorageUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                subject: this.state.subject,
                description : this.state.description,
                comment: this.state.comment,
                url: this.state.url,
                category: this.state.category,
                s3location: this.state.fileLocation
            })
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({
                success: true,
                successMsg: "File saved in database!"
            })
        })
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })
        })
        
        fetch('https://discord.com/api/webhooks/886696379961987072/hPTfwfZ_hB9tL0COhcPf-iHpxfPZ3GuYjyvubMmyzXEffaW924Dky-O1GSC6EEMbNUSw', {
            method: 'POST',
            headers: { "Content-Type": "application/json" , "Authorization": accessToken },
            body: JSON.stringify({
                "content": "NEW FILE IS UPLOADED",
                "embeds": [{
                        "title": this.state.subject,
                        "description" : this.state.description,
                        "thumbnail" : {
                            "url": this.state.fileLocation
                        }
                }] 
            })
        })
        .then(res => res.json())
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })
        })
    }

    errorHandling = () => {
        this.setState({
            error: false,
            errorMsg: ""
        })
    }
    successHandling = () => {
        this.setState({
            success: false,
            successMsg: ""
        })
    }


    render() {
        return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                
                            <Breadcrumbs title="Data Store" breadcrumbItems={this.state.breadcrumbItems} />
                            <Row>
                                <Col lg={12}>
                                <Card>
                                <CardBody>
                                
                                <FormGroup row className="mb-0" >
                                <Label className="col-md-2 col-form-label">Category</Label>
                                <Col md={10}>
                                <select className="custom-select" id="category" placeholder="pick" onChange={this.detailState}>
                                    <option defaultValue value="">Select category</option>
                                    <option value="concentrationcamps">Concentration camps</option>
                                    <option value="facility">Facility</option>
                                    <option value="videointerview">Video Interview</option>
                                    <option value="writtentestimony">Written Testimony</option>
                                    <option value="forcedlabour">Forced Labour</option>
                                    <option value="seperatedfamily">Seperated family</option>
                                    <option value="demolishment">Demolishment</option>
                                    <option value="internaldocs">Internal Documents</option>
                                    <option value="concentrationcamps/3d">Camp 3D Model</option>
                                    <option value="uyghurtribunal">Uyghur Tribunal</option>
                                    <option value="researchpapers">Research Papers</option>
                                    <option value="documentsforreview">Documents for Review</option>
                                    <option value="officialpapers">Official Chinese Documents</option>
                                    <option value="digitalbook">Digital Book</option>
                                    <option value="utjd">UTJD Related Documents</option>
                                    <option value="others">Others</option>
                                </select>
                                </Col>
                                </FormGroup>
                                <FormGroup row>
                                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">Provide subfolder</Label>
                                        <Col md={10}>
                                        
                                        <Input className="form-control" type="text" placeholder="/subfolder" id="subfolder" onChange={this.detailState}/>
                                        <p className="card-title-desc"> Please provide subfolder if required. Has to follow strictly following rule  Ex:<em>/subfolder</em>. Each subfolder has to start / sign followed by name for subfolder </p>
                                        </Col>
                                    </FormGroup>
                                </CardBody>
                                </Card>
                                </Col>
                                
                                <Col lg={12}>
                                <Card>
                                {this.state.category !== "" ? 
                                <CardBody>
                                    
                                    <h4 className="card-title">File browser 
                                        <div className="">
                                                    <Progress striped animated color="primary" value={this.state.uploaded} />
                                        </div>
                                    </h4>
                                    <p className="card-title-desc"> Please <em>Choose file…</em> you want upload. Big size files may require some time please do not leave the page </p>
                                    <div className="custom-file mb-4">
                                        <CustomInput type="file" className="custom-file-input" id="customFile" onChange={this.fileAutoSubmitToS3}/>
                                        <Label className="custom-file-label" htmlFor="customFile">Choose file</Label>
                                        {this.state.fileUploading ? <div role="status" class="me-2 spinner-border text-info">
                                            <span className="sr-only">Loading...</span></div> 
                                            : ""
                                        }
                                        <span>Uploaded size in percentage: {this.state.uploaded} %</span>
                                        <Alert color="success" isOpen={this.state.fileSuccess} >
                                            {this.state.fileName} uploaded
                                        </Alert>
                                    </div>
                                </CardBody>
                                :
                                ""
                                }
                                {this.state.fileSuccess && this.state.category !== "" ? 
                                
                                <CardBody>
                                    <h4 className="card-title">File Subject</h4>
                                    <div className="mb-4">
                                        <Input className="form-control" type="text" placeholder="Subject/Mezmun/مەزمۇن" id="subject" onChange={this.detailState}/>
                                    </div>
                                    <h4 className="card-title">Details</h4>
                                    <p className="card-title-desc">Provide Details below</p>
                
                                    <FormGroup row>
                                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">Description</Label>
                                        <Col md={10}>
                                        <Input className="form-control" type="text" placeholder="Description on file submitted" id="description" onChange={this.detailState}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">Comment</Label>
                                        <Col md={10}>
                                        <Input className="form-control" type="text" placeholder="Your Comment" id="comment" onChange={this.detailState}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label htmlFor="example-url-input" className="col-md-2 col-form-label">URL</Label>
                                        <Col md={10}>
                                        <Input className="form-control" type="url" placeholder="https://referance.com"  id="url" onChange={this.detailState}/>
                                        </Col>
                                    </FormGroup>
                                    
                                    <Button color="primary" className="w-md waves-effect waves-light" onClick={this.onSend}>Submit File</Button>

                                    <div className="mt-5 text-center">
                                        <Alert color="success" isOpen={this.state.success} toggle={this.successHandling}>
                                        {this.state.successMsg}
                                        </Alert>
                                    </div>
                                    <div className="mt-5 text-center">
                                        <Alert color="danger" isOpen={this.state.error} toggle={this.errorHandling} fade={true}>
                                        {this.state.errorMsg}
                                        </Alert>
                                    </div>
                                   
                                </CardBody>
                                :
                                ""
                                }
                                
                                </Card>
                                </Col>
                                
                            </Row>
                        </Container>
                    </div>
                </React.Fragment>

                )
    }
}
